// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  featureRecurso: true,
  possui: false,
  api: 'https://processossemuttran.homologacao.promultonline.com.br',
  urlImpressao: "http://impressao.homologacao.promultonline.com.br/",
  urlProcessamento: "http://processamento.homologacao.promultonline.com.br/Processamento/PrincipalProcessamento.aspx",
  auth: {
    issuer: 'https://identity.auth.promultonline.com.br',
    clientId: 'processosadmpiracicaba',
    postLogoutRedirectUri: 'https://processossemuttran.homologacao.promultonline.com.br',
    redirectUri: 'https://processossemuttran.homologacao.promultonline.com.br/signin-oidc',
    scope:"openid profile email processosadmpiracicaba management",
    oidc: true,
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
